<div class="phone-case">
  <div class="phone-speaker"></div>
  <div class="phone-screen">
    <img src="/assets/images/status-bar.png" width="240" />
    <ng-content></ng-content>
  </div>
</div>
